import { render, staticRenderFns } from "./TeamOverview.vue?vue&type=template&id=45a19163&scoped=true&"
import script from "./TeamOverview.vue?vue&type=script&lang=js&"
export * from "./TeamOverview.vue?vue&type=script&lang=js&"
import style0 from "./TeamOverview.vue?vue&type=style&index=0&id=45a19163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a19163",
  null
  
)

export default component.exports